declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

// GTM側のトリガーは「イベント名が ^nekometry_ に一致」で設定しているため、
// カスタムイベント名は必ず nekometry_ で始める
export type NekometryAction =
  | "nekometry_x_share"
  | "nekometry_markdown_export"
  | "nekometry_food_usage_submit"
  | "nekometry_calculate_food_add"
  | "nekometry_calculator_start"
  | "nekometry_calculator_result_view"
  | "nekometry_calculator_formula_change"
  | "nekometry_food_request_open"
  | "nekometry_article_report_open"
  | "nekometry_age_convert"
  | "nekometry_food_label_ocr_start"
  | "nekometry_food_label_ocr_result"
  | "nekometry_share_image_download"
  | "nekometry_first_cat_feedback_open"
  | "nekometry_first_cat_start"
  | "nekometry_first_cat_resume"
  | "nekometry_first_cat_month_reach"
  | "nekometry_first_cat_finish"
  | "nekometry_nekosei_start"
  | "nekometry_nekosei_choice"
  | "nekometry_nekosei_speed_change"
  | "nekometry_nekosei_auto_toggle"
  | "nekometry_nekosei_finish"
  | "nekometry_nekosei_share";

export function trackAction(
  action: NekometryAction,
  params?: Record<string, string | number>,
): void {
  if (typeof window === "undefined") return;
  window.dataLayer ??= [];
  window.dataLayer.push({ event: action, ...params });
}
